import styles from "@styles/pages/flow/Flow.module.scss";
import classNames from "classnames/bind";
import { Radio } from "../../components/Radio";
import { If } from "../../components/control-statements";
import { Dates } from "../../utils/Dates";
const css = classNames.bind(styles);

export const ChangeHistorySidebar = ({
  visible,
  changes,
  selectedChange,
  onSelectChange,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className={styles.historic}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <i className="fal fa-list-radio" />
        </div>
        <p className={styles.title}>Histórico de alterações</p>
      </div>

      <If cond={!!changes || changes?.lengh > 0}>
        <div className={styles.changes}>
          {(changes ? [...changes].reverse() : []).map((change, _i) => (
            <div
              key={_i}
              className={css({
                change: true,
                active: change?.id === selectedChange,
              })}
              onClick={() => onSelectChange(change)}
            >
              <div className={styles.date}>
                <Radio value={change?.id} checked={selectedChange} />
                <p>
                  {convertDate(change?.created_at)} -{" "}
                  {Dates.toTimeBRL(change?.created_at)}
                </p>
              </div>
              <div className={styles.duration}>
                <i className="fal fa-calendars" />
                {getDaysAndHoursPassed(change?.created_at)}
              </div>
            </div>
          ))}
        </div>
      </If>
    </div>
  );
};

const convertDate = (date) => {
  const dateObj = new Date(date);
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
    dateObj
  );
  return formattedDate;
};

const getDaysAndHoursPassed = (dateStr) => {
  const date = new Date(dateStr);
  const now = new Date();

  const diffInMilliseconds = now - date;

  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
  const diffInHours = Math.floor((diffInMilliseconds / (1000 * 60 * 60)) % 24);
  const diffInMinutes = Math.floor((diffInMilliseconds / (1000 * 60)) % 60);

  if (diffInDays === 0) {
    return diffInHours > 1
      ? `${diffInHours} horas`
      : `${diffInMinutes} Minutos`;
  }
  return `${diffInDays} dias`;
};
